enum iaqDevicesType {
  GET_IAQ_DEVICES_START = "GET_IAQ_DEVICES_START",
  GET_IAQ_DEVICES_SUCCESS = "GET_IAQ_DEVICES_SUCCESS",
  GET_IAQ_DEVICES_ERROR = "GET_IAQ_DEVICES_ERROR",
  RESET_IAQ_DEVICES = "RESET_IAQ_DEVICES",
  GET_IAQ_LEGENDS_DETAILS_START = "GET_IAQ_LEGENDS_DETAILS_START",
  GET_IAQ_LEGENDS_DETAILS_SUCCESS = "GET_IAQ_LEGENDS_DETAILS_SUCCESS",
  GET_IAQ_LEGENDS_DETAILS_ERROR = "GET_IAQ_LEGENDS_DETAILS_ERROR",
  RESET_IAQ_LEGENDS_DETAILS = "RESET_IAQ_LEGENDS_DETAILS",
  GET_IAQ_SENSOR_FILTER_START = "GET_IAQ_SENSOR_FILTER_START",
  GET_IAQ_SENSOR_FILTER_SUCCESS = "GET_IAQ_SENSOR_FILTER_SUCCESS",
  GET_IAQ_SENSOR_FILTER_ERROR = "GET_IAQ_SENSOR_FILTER_ERROR",
  RESET_IAQ_SENSOR_FILTER_STATE= "RESET_IAQ_SENSOR_FILTER_STATE"
}

export default iaqDevicesType;
